var map = {
	"./gar1.webp": 5078,
	"./gar2.webp": 6103,
	"./gar3.webp": 3092,
	"./gar4.webp": 4885,
	"./gar5.webp": 3386,
	"./gar6.webp": 235,
	"./gar7.webp": 3784,
	"./gar8.webp": 7641,
	"./gar9.webp": 8542,
	"./garlandImages": 9800,
	"./garlandImages.jsx": 9800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7273;